// Single source of the file-upload chip label, shared by the live upload path and history
// rendering so a reloaded conversation shows the same chip as the live session.
export const attachmentChipText = (fileName?: string | null): string =>
  fileName ? `📎 Attached file: ${fileName}` : "📎 Attached file";
